import React, { useState } from 'react';

function ChipBoard({ players, currentUser, onUpdateChips }) {
  const [editingPlayer, setEditingPlayer] = useState(null);
  const [newChips, setNewChips] = useState('');

  const handleEditClick = (player) => {
    setEditingPlayer(player.id);
    setNewChips(player.chips.toString());
  };

  const handleSaveChips = async (playerId) => {
    const chips = parseInt(newChips);
    if (isNaN(chips) || chips < 0) {
      alert('请输入有效的筹码数量');
      return;
    }

    try {
      await onUpdateChips(playerId, chips);
      setEditingPlayer(null);
      setNewChips('');
    } catch (error) {
      console.error('更新筹码失败:', error);
      alert('更新筹码失败，请重试');
    }
  };

  const handleCancelEdit = () => {
    setEditingPlayer(null);
    setNewChips('');
  };

  return (
    <div className="chip-board">
      <div className="chip-board-title">
        💰 筹码板
      </div>
      
      <div className="chip-list">
        {players.map((player) => (
          <div 
            key={player.id} 
            className={`chip-item ${player.id === currentUser.id ? 'current-player' : ''}`}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <span>{player.player_name}</span>
              {player.is_host && (
                <span style={{ 
                  fontSize: '12px', 
                  background: '#fbbf24', 
                  color: '#000', 
                  padding: '2px 6px', 
                  borderRadius: '4px' 
                }}>
                  房主
                </span>
              )}
            </div>
            
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              {editingPlayer === player.id ? (
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <input
                    type="number"
                    value={newChips}
                    onChange={(e) => setNewChips(e.target.value)}
                    className="input"
                    style={{ 
                      width: '80px', 
                      padding: '4px 8px', 
                      fontSize: '14px',
                      margin: 0 
                    }}
                    min="0"
                    max="999999"
                  />
                  <button
                    onClick={() => handleSaveChips(player.id)}
                    className="btn btn-success"
                    style={{ 
                      padding: '4px 8px', 
                      fontSize: '12px',
                      minWidth: '40px' 
                    }}
                  >
                    ✓
                  </button>
                  <button
                    onClick={handleCancelEdit}
                    className="btn btn-secondary"
                    style={{ 
                      padding: '4px 8px', 
                      fontSize: '12px',
                      minWidth: '40px' 
                    }}
                  >
                    ✕
                  </button>
                </div>
              ) : (
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <span style={{ fontWeight: 'bold' }}>
                    {player.chips}
                  </span>
                  {currentUser.isHost && (
                    <button
                      onClick={() => handleEditClick(player)}
                      className="btn btn-primary"
                      style={{ 
                        padding: '4px 8px', 
                        fontSize: '12px',
                        minWidth: '40px' 
                      }}
                    >
                      编辑
                    </button>
                  )}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>

      {players.length === 0 && (
        <div style={{ 
          textAlign: 'center', 
          color: '#9ca3af', 
          padding: '20px' 
        }}>
          暂无玩家
        </div>
      )}

      {currentUser.isHost && (
        <div style={{ 
          marginTop: '15px', 
          padding: '10px', 
          backgroundColor: 'rgba(59, 130, 246, 0.1)', 
          borderRadius: '8px',
          fontSize: '14px',
          color: '#d1d5db'
        }}>
          <strong>房主提示：</strong>
          <br />
          • 您可以编辑任何玩家的筹码
          • 建议在每局游戏后更新筹码
          • 筹码数量不能为负数
        </div>
      )}
    </div>
  );
}

export default ChipBoard; 